import { createAction, props } from '@ngrx/store';
import { Quote } from '@lockton-apps/shared/interfaces';

export enum QuoteOptionsActionsTypes {
  Init = '[Quote Options Page] Initialised',
  QuoteSentToClient = '[Quote Options Page] Quote Sent To Client',
  QuoteAccepted = '[Quote Options Page] Quote Accepted',
}

export const QuoteOptionsActions = {
  init: createAction(QuoteOptionsActionsTypes.Init),
  quoteSentToClient: createAction(
    QuoteOptionsActionsTypes.QuoteSentToClient,
    props<{ quote: Quote }>()
  ),
  quoteAccepted: createAction(
    QuoteOptionsActionsTypes.QuoteAccepted,
    props<{ quote: Quote }>()
  ),
};
